import graphqlClient from "../../../apollo";

class TamanioProvider {

    findTamanio(id) {
        return graphqlClient.query({
            query: require('./gql/tamanioFind.graphql'),
            variables: { id: id },
            fetchPolicy: "network-only"
        })
    }

    fetchTamanios() {
        return graphqlClient.query({
            query: require('./gql/tamanioFetch.graphql'),
            fetchPolicy: "network-only"
        })
    }

    paginateTamanios(pageNumber, itemsPerPage, search = null, orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/tamanioPaginate.graphql'),
            variables: { pageNumber, itemsPerPage, search, orderBy, orderDesc },
            fetchPolicy: "network-only"
        })
    }

    getTamanioUpdateImpact(tamanioId) {
        return graphqlClient.query({
            query: require('./gql/tamanioUpdateImpact.graphql'),
            variables: { tamanioId },
            fetchPolicy: "network-only"
        })
    }

    createTamanio(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/tamanioCreate.graphql'),
            variables: form
        })
    }

    updateTamanio(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/tamanioUpdate.graphql'),
            variables: form
        })
    }

    deleteTamanio(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/tamanioDelete.graphql'),
            variables: { id }
        })
    }

}

export default new TamanioProvider()


